module.exports = __webpack_public_path__ + "img/logo-login.d93ac8c2.png";